import { render } from "./BudgetParamsForm.vue?vue&type=template&id=4b71254b&scoped=true"
import script from "./BudgetParamsForm.vue?vue&type=script&lang=js"
export * from "./BudgetParamsForm.vue?vue&type=script&lang=js"

import "./BudgetParamsForm.vue?vue&type=style&index=0&id=4b71254b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b71254b"]])

export default __exports__